var _defs, _rect, _rect2, _path, _rect3, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WelderShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dsFYE07O3DxK_5yzL9ooEa",
    x1: 35,
    x2: 42,
    y1: 19,
    y2: 19,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 155",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dsFYE07O3DxK_5yzL9ooEb",
    x1: 6,
    x2: 13,
    xlinkHref: "#dsFYE07O3DxK_5yzL9ooEa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dsFYE07O3DxK_5yzL9ooEc",
    x1: 16.251,
    x2: 34.165,
    y1: -2.139,
    y2: 47.08,
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442\\u043D\\u043E\\u0439 \\u0437\\u0430\\u043B 3",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ea2e4"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 6,
    x: 35,
    y: 16,
    fill: "url(#dsFYE07O3DxK_5yzL9ooEa)",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 6,
    x: 6,
    y: 16,
    fill: "url(#dsFYE07O3DxK_5yzL9ooEb)",
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dsFYE07O3DxK_5yzL9ooEc)",
    d: "M11,5H37a2,2,0,0,1,2,2V29A15,15,0,0,1,24,44h0A15,15,0,0,1,9,29V7a2,2,0,0,1,2-2Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 12,
    x: 12,
    y: 13,
    fill: "#50e6ff",
    rx: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35,14V24H13V14H35m0-1H13a1,1,0,0,0-1,1V24a1,1,0,0,0,1,1H35a1,1,0,0,0,1-1V14a1,1,0,0,0-1-1Z",
    opacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35,13.5a.50053.50053,0,0,1,.5.5V24a.50053.50053,0,0,1-.5.5H13a.50053.50053,0,0,1-.5-.5V14a.50053.50053,0,0,1,.5-.5H35m0-.5H13a1,1,0,0,0-1,1V24a1,1,0,0,0,1,1H35a1,1,0,0,0,1-1V14a1,1,0,0,0-1-1Z",
    opacity: 0.07
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WelderShield);
export default __webpack_public_path__ + "static/media/icons8-welder-shield.9015f8320b16319c33c80649b9ede6f4.svg";
export { ForwardRef as ReactComponent };